import { createStyles } from "@mantine/core";

const EmployerImporterReferenceFieldTableStyles = createStyles(() => ({
  container: {
    width: "280px",
    // height: "414px",
    flexGrow: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "stretch",
    padding: 0,
    borderRadius: "8px",
    border: "solid 2px var(--grey-grey-30)",
    backgroundColor: "var(--background-background-light)",
  },
  topSection: {
    height: "188px",
    alignSelf: "stretch",
    flexGrow: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "stretch",
    gap: "16px",
    padding: "24px 24px 16px",
    backgroundColor: " var(--background-background-light)",
  },
  descriptorBar: {
    height: "28px",
    alignSelf: "stretch",
    flexGrow: 0,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 0,
  },
  descriptionTags: {
    width: "82px",
    height: "28px",
    flexGrow: 0,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: " 6px",
    padding: "6px",
    borderRadius: "4px",
    backgroundColor: "#f5fcea",
  },
  descriptionStatus: {
    flexGrow: 0,
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1,
    letterSpacing: "normal",
    textAlign: "left",
    color: "#ff922b",
  },
  descriptionMatchStatus: {
    color: "#94d82d",
  },
  bottomSection: {
    // height: "170px",
    alignSelf: "stretch",
    flexGrow: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "stretch",
    // padding: "0 0 8px",
  },
  label: {
    height: "24px",
    alignSelf: "stretch",
    flexGrow: 0,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "3px",
    padding: "0 0 8px",
  },
  text: {
    height: "16px",
    flexGrow: 0,
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.16px",
    textAlign: "left",
    color: " var(--grey-grey-80)",
  },
  headerRow: {
    height: "40px",
    alignSelf: "stretch",
    flexGrow: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "8px",
    padding: "0 24px;",
    backgroundColor: "var(--background-background)",
  },
  row: {
    height: "40px",
    alignSelf: "stretch",
    flexGrow: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "8px",
    padding: "0 24px;",
    // backgroundColor: "var(--background-background)",
    boxShadow: "0 1px 0 0 var(--grey-grey-30)",
    backgroundColor: "var(--background-background-light)",
  },
  header: {
    flexGrow: 0,
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.16px",
    textAlign: "left",
    color: "var(--grey-grey-80)",
  },
  rowLabel: {
    flexGrow: 0,
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.43",
    letterSpacing: "0.16px",
    textAlign: "left",
    color: "var(--grey-grey-80)",
  },
  unMatchDescriptionTags: {
    backgroundColor: "#fff5ea",
    width: "96px",
  },
  unMatchContainer: {
    borderRadius: "8px",
    border: "solid 2px #ffdfc0",
  },
}));

export default EmployerImporterReferenceFieldTableStyles;
